import { render, staticRenderFns } from "./ExpertAppointmentTable.vue?vue&type=template&id=5e97d9c0"
import script from "./ExpertAppointmentTable.vue?vue&type=script&lang=ts"
export * from "./ExpertAppointmentTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports